import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Divider from "@mui/material/Divider";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

const BranchInfoWindow = ({ info }) => {
  const { name, address, phoneNumber, bookUrl, position } = info;

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "25px",
        padding: { xs: "0.5px 0.5px 0.5px 0.5px", sm: "1px 1px 1px 1px" },
      }}
    >
      <Stack spacing={{ xs: 1, sm: 2 }}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LocationOnIcon
              sx={{ mr: 1, fontSize: { xs: "0.8rem", sm: "1.25rem" } }}
            />
            <Typography
              sx={{ fontSize: { xs: "0.8rem", sm: "1.25rem" } }}
              variant="subtitle2"
            >
              {name}
            </Typography>
          </Box>
        </Box>
        <Divider variant="middle" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Typography variant="caption">{address}</Typography>
          <Button
            variant="outlined"
            startIcon={<LocalPhoneIcon />}
            sx={{
              borderRadius: "25px",
              fontSize: { xs: "0.645rem", sm: "0.875rem" },
            }}
          >
            {phoneNumber}
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            variant="text"
            sx={{
              fontWeight: 600,
              mr: 2,
              fontSize: { xs: "0.675rem", sm: "0.8125rem" },
            }}
            href={`https://maps.google.com?q=${position.lat},${position.lng}`}
            target="_blank"
            size="small"
          >
            Visit Location
          </Button>
          <Button
            color="yellow"
            variant="contained"
            sx={{
              borderRadius: "25px",
              marginTop: "2px",
              fontWeight: 600,
              fontSize: { xs: "0.675rem", sm: "0.8125rem" },
            }}
            href={bookUrl}
            target="_blank"
            size="small"
          >
            Book Online
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default BranchInfoWindow;
